import { useEffect, useState } from "react"

import { Dropdown, Flex, Input, Modal, Typography } from "antd"
import classname from "classname"

import Icon from "../../../../../Icon"
import { statusTextMap } from "../../utils/constants"
import { getStatusUpdateOptions } from "../../utils/statusUpdateOptions"

import styles from "./StatusTag.module.less"

const { Text } = Typography
const { TextArea } = Input

const StatusTag = ({ status, onChange }) => {
  const [statusUpdating, setStatusUpdating] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState("")
  const [openRejectReasonModal, setOpenRejectReasonModal] = useState(false)
  const statusUpdateOptions = getStatusUpdateOptions(status)
  const hasStatusUpdateOptions = statusUpdateOptions.length > 0

  const handleChangeMenuOpen = (open, info) => {
    if (info?.source === "menu") return
    setMenuOpen(open)
  }

  const updateStatus = async (newStatus) => {
    if (newStatus === "rejected" && !rejectReason) {
      setOpenRejectReasonModal(true)
      return
    }
    try {
      setStatusUpdating(true)
      await onChange?.({ status: newStatus })
      setStatusUpdating(false)
      setMenuOpen(false)
    } catch (error) {
      setStatusUpdating(false)
    }
  }

  const handleRejectConfirm = async () => {
    try {
      setStatusUpdating(true)
      const reason = rejectReason.trim()
      await onChange?.({ status: "rejected", rejectReason: reason })
      setOpenRejectReasonModal(false)
      setStatusUpdating(false)
      setMenuOpen(false)
      setRejectReason("")
    } catch (e) {
      setStatusUpdating(false)
    }
  }

  const handleRejectCancel = () => {
    setOpenRejectReasonModal(false)
    setRejectReason("")
  }

  useEffect(() => {
    setRejectReason("")
    setOpenRejectReasonModal(false)
    setStatusUpdating(false)
  }, [])

  if (!hasStatusUpdateOptions) {
    return (
      <div
        className={classname(styles.tag, styles[status])}
        style={{ margin: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <Text className={styles.text} strong>
          {statusTextMap?.[status] || status}
        </Text>
      </div>
    )
  }

  return (
    <>
      <Modal
        open={openRejectReasonModal}
        classNames={{ content: "clear-bg" }}
        title="Rejection reason"
        okText="Confirm rejection"
        cancelText="Cancel"
        onOk={handleRejectConfirm}
        onCancel={handleRejectCancel}
        okButtonProps={{
          disabled: !rejectReason.trim(),
          loading: statusUpdating
        }}
        centered
        destroyOnClose
      >
        <TextArea
          autoFocus
          placeholder="Type rejection reason here…"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
      <Dropdown
        getPopupContainer={() => document.getElementById("main-layout")}
        destroyPopupOnHide={true}
        overlayClassName={styles.dropdown}
        trigger={["click"]}
        open={menuOpen}
        onOpenChange={handleChangeMenuOpen}
        menu={{
          items: [status, ...statusUpdateOptions].map((el) => ({
            key: el,
            disabled: el === status || statusUpdating,
            label: (
              <Flex align="center" justify="space-between">
                <Flex className={styles.dropdownStatusOption} gap={8} align="center">
                  <div className={styles.statusIndicatorContainer}>
                    <div className={classname(styles.statusIndicator, styles[el])}></div>
                  </div>
                  <Text>{statusTextMap?.[el] || el}</Text>
                </Flex>
                {el === status && <Icon type="check" className={styles.checkIcon} />}
              </Flex>
            )
          })),
          onClick: ({ key, domEvent }) => {
            domEvent.stopPropagation()
            updateStatus(key)
          }
        }}
      >
        <div
          key={status}
          className={classname(styles.tag, styles[status])}
          style={{ margin: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <Flex gap={8} align="center">
            <Text className={styles.text} strong>
              {statusTextMap?.[status] || status}
            </Text>
            <Icon type="chevron_down_small" style={{ marginLeft: -4, marginRight: -4 }} />
          </Flex>
        </div>
      </Dropdown>
    </>
  )
}

export default StatusTag
